
export class BaseService {
    public static  BACKEND_URL = process.env.REACT_APP_API_URL;
}

